import Language from "@mui/icons-material/Language";
import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { HXMobileMenuButton } from "./HXMenuButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import HXMenuItem from "./HXMenuItem";
import { LightSmallText } from "./HXDesktopPage.styles";
export const HXLanguageChangerButtonActionMenuButton = styled(HXMobileMenuButton).attrs({ text: true, label: "" }) `
    padding: 8px;
    background: transparent;
    height: 33px;

    & .MuiButton-startIcon {
        margin-right: 4px;
    }

    & .MuiButton-endIcon {
        margin-left: 4px;
    }

    &:hover {
        background: ${colors.black_8};
    }

    ${({ isTypeFullText }) => isTypeFullText &&
    css `
            padding: 8px 16px;
            background: ${colors.black_8};
            &:hover {
                background: ${colors.black_12};
            }
        `}

    ${({ center }) => center &&
    css `
            align-self: center;
        `}
`;
export const HXLanguageChangerButtonTranslateIcon = styled(Language) `
    color: ${colors.black_lighter};
    ${({ isTypeFullText }) => isTypeFullText &&
    css `
            color: ${colors.black_light};
            width: 16px;
            height: 16px;
        `}
`;
export const HXLanguageChangerButtonExpandMoreIcon = styled(ExpandMoreIcon) `
    color: ${colors.black_light};
    width: 14px;
    height: 14px;
    transition: transform 0.2s ease-out !important;
    transform: ${({ expanded }) => (expanded ? "rotate(180deg)" : "rotate(0deg)")};
`;
export const HXLanguageChangerMenuContainer = styled(FlexColumnDiv) `
    min-width: 133px;
`;
export const HXLanguageChangerMenuItem = styled(HXMenuItem) `
    min-height: 17px;
    gap: 16px;
    padding: 8px 16px;
`;
export const HXLanguageChangerMenuCheckText = styled(LightSmallText) `
    flex: 1;
`;
export const HXLanguageChangerMenuCheckIcon = styled(CheckIcon) `
    color: ${colors.black_light};
    width: 16px;
    height: 16px;
`;
